import Col from '@loggi/ui/components/col';
import DisplayInfo from '@loggi/ui/components/display-info';
import Image from '@loggi/ui/components/image';
import colors from '@loggi/ui/components/utils/colors';
import icons from '@loggi/ui/components/utils/icons';
import PropTypes from 'prop-types';
import React from 'react';
import './driver-info.styles.scss';

const fontSize = 28;
const styleFallbackBg = {
  background: colors.hex.light,
  maxHeight: fontSize * 2,
  maxWidth: fontSize * 2,
  fontSize
};
export const DRIVER = 'Entregador';

export default function DriverInfo({ photoUrl, name }) {
  return (
    <Col
      gutter={{ top: 'normal' }}
      flexDirection="row"
      alignItems="center"
      justifyContent="start"
      className="driverInfo"
    >
      <Image
        src={photoUrl}
        shape="circle"
        styleFallback={styleFallbackBg}
        iconTypeFallback={icons.type.HELMET}
        iconColorFallback={colors.type.WHITE}
      />
      <Col flexGrow="1" gutter={{ left: 'normal' }}>
        <DisplayInfo bottomGutter={null} label={DRIVER} text={name} />
      </Col>
    </Col>
  );
}

DriverInfo.displayName = 'DriverInfo';
DriverInfo.propTypes = {
  photoUrl: PropTypes.string,
  name: PropTypes.string.isRequired
};
DriverInfo.defaultProps = {
  photoUrl: null
};
